import { jsx as _jsx } from "react/jsx-runtime";
import { NavigationRoutes } from '../../../../../modules/Header/constants/navigationRoutes';
import { MobileLinksList } from './MobileLinksList';
const ACCESSORIES_LINKS = [
    {
        name: 'Mounting & Add-ons',
        url: NavigationRoutes.ACCESSORIES,
    },
    {
        name: 'Gift Cards',
        url: NavigationRoutes.GIFT_CARD,
    },
];
export const AccessoriesSubNavigation = () => (_jsx(MobileLinksList, { links: ACCESSORIES_LINKS }, void 0));
//# sourceMappingURL=AccessoriesSubNav.js.map